import { render, staticRenderFns } from "./SidebarNestedItem.vue?vue&type=template&id=c7e60cde&scoped=true&"
import script from "./SidebarNestedItem.vue?vue&type=script&lang=js&"
export * from "./SidebarNestedItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNestedItem.vue?vue&type=style&index=0&id=c7e60cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e60cde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup,VListItem,VListItemIcon,VListItemTitle})
